import React, { useEffect, useState } from 'react';
import { useLocationImage } from '../../hooks/useLocationImage';

/**
 * Stedsnøyaktig bilde (Mapillary / Street View) øverst i en kartlag-popup.
 * `enabled` MÅ kun være true når popup-en faktisk er åpen — ellers ville hooken
 * fyre for hver markør på skjermen (kostnadseksplosjon). Backend cacher
 * avgjørelsen per geo-nøkkel, så gjentatte åpninger er gratis.
 */
const PopupLocationImage: React.FC<{ lat: number; lng: number; enabled: boolean }> = ({ lat, lng, enabled }) => {
  const img = useLocationImage(lat, lng, enabled);
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [img?.url]);
  if (!img?.url || failed) return null;
  const label = img.source === 'streetview'
    ? '© Google Street View'
    : img.credit ? `Mapillary · ${img.credit}` : 'Mapillary';
  return (
    <div className="relative -mx-3 -mt-3 mb-1 overflow-hidden rounded-t-lg">
      <img
        src={img.url}
        alt=""
        className="w-full h-28 object-cover"
        loading="lazy"
        onError={() => setFailed(true)}
      />
      <span className="absolute bottom-1 right-1 bg-black/60 text-white text-[8px] px-1 py-0.5 rounded pointer-events-none">
        {label}
      </span>
    </div>
  );
};

export default PopupLocationImage;
